import type { UserContextEvent } from '../telemetry-models';

/**
 * Origin information from ancestorOrigins
 */
export type OriginsInfo = Pick<UserContextEvent, 'ancestor_origins'>;

/**
 * Detects ancestor origins information
 * Implements the detector pattern using static methods
 */
export class OriginsDetector {
  /**
   * Detect ancestor origins (synchronous)
   */
  static detect(): OriginsInfo {
    return {
      ancestor_origins: this._getAncestorOrigins(),
    };
  }

  /**
   * Get ancestor origins from window.location
   */
  private static _getAncestorOrigins(): string[] {
    try {
      if (!window.location.ancestorOrigins) {
        return [];
      }

      // Convert DOMStringList to array
      return Array.from(window.location.ancestorOrigins);
    } catch {
      return [];
    }
  }
}
